import PropTypes from 'prop-types'

import './mobileHeaderEverplansBrandedCobranding.scss'

const MobileHeaderEverplansBrandedCobranding = ({
  cobranding: {
    cobranding_prefix = '',
    cobrandable = {name: ''}
  } = {}
}) => (
  <div className='mobile-header-everplans-branded-cobranding'>
    <div>{cobranding_prefix}</div>
    <div>{cobrandable.name}</div>
  </div>
)

MobileHeaderEverplansBrandedCobranding.propTypes = {
  cobranding: PropTypes.shape({
    cobranding_prefix: PropTypes.string,
    cobrandable: PropTypes.shape({
      name: PropTypes.string
    })
  })
}

export default MobileHeaderEverplansBrandedCobranding
